module.exports = __webpack_public_path__ + "media/images/faqs/bg-1440-28c12ebcbccb9ab17be75886b4aeb1e5.png";